<template>
  <div class="privacy">
    <header-top :headerPosition="false">
      <div slot="title">{{ appName }}隐私政策</div>
    </header-top>
    <div class="privacy-wrapper">
      <div class="privacy-date">发布日期：2022年09月28日</div>
      <div class="privacy-date privacy-date-second">
        生效日期：2022年09月28日
      </div>
      <div class="privacy-title">提示条款</div>
      <div class="privacy-content">
        “{{
          appName
        }}”的运营主体成都陌陌科技有限公司（以下简称“我们”）深知个人信息对您的重要性，并会尽力保护您的个人信息安全可靠，我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则，目的明确原则，选择同意原则，最少够用原则，确保安全原则，主体参与原则，公开透明原则等等。同时我们承诺，我们将按业界成熟的安全解决方案，采取相应的安全保护措施来保护您的个人信息。鉴此，我们制定本《隐私政策》（下称“本政策
        /本隐私政策”）并提醒您：
      </div>
      <div class="privacy-content">本政策适用于“{{ appName }}”软件及相关服务。</div>
      <div class="privacy-content">
        <b
          >在使用“{{
            appName
          }}”软件及相关服务前，请您务必仔细阅读并理解本政策，在确认充分理解并同意后使用相关产品或服务。</b
        >如对本政策内容有任何疑问、意见或建议，您可通过“{{ appName }}”提供的各种联系方式与我们联系。
      </div>
      <div class="privacy-content">
        <b>本隐私政策部分将帮助您了解以下内容：</b>
      </div>
      <div class="privacy-content">
        一、我们向您收集的个人信息及其用途
        <br />
        <br />二、我们可能需要获取的您的设备权限
        <br />
        <br />三、我们如何共享、转让、披露您的个人信息
        <br />
        <br />四、我们如何保护您的个人信息
        <br />
        <br />五、您如何管理您的个人信息
        <br />
        <br />六、我们如何处理未成年人的个人信息
        <br />
        <br />七、我们存储您的个人信息的位置和方式
        <br />
        <br />八、本隐私政策如何更新
        <br />
        <br />九、如何联系我们
      </div>
      <div class="privacy-title">一、我们向您收集的个人信息及其用途</div>
      <div class="privacy-content">
        <b>个人信息</b
        >是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，我们将以下述目的，收集和使用您的个人信息：
      </div>
      <div class="privacy-content">
        （一） 我们会收集您的
        <b>手机号码、昵称、性别、生日，</b>用于为您创建“{{
          appName
        }}”的账号并为您提供相关服务；我们会收集您
        <b>在微信的注册账号相关信息（头像、昵称及您授权的其他信息）及手机号码</b
        >（用来绑定账号），用于为您创建“{{ appName }}”的账号并为您提供相关服务。
      </div>
      <div class="privacy-content">
        （二） 我们会收集您的
        <b>身份信息（真实姓名和身份证号）</b
        >，用于您申请成为红娘/月老或者提现时按照国家法律规定为您完成实名认证。
      </div>
      <div class="privacy-content">
        （三） 我们会收集您选择上传的或自主自愿拍摄的
        <b>头像照片</b>，用于为您创建“{{ appName }}”的账号头像。
      </div>
      <div class="privacy-content">
        （四） 我们会收集您填写的
        <b>身高、体重、标签设置</b
        >用于创建账号后使其他用户更加的了解您以及用于我们为您提供更契合您需求的服务。在注册与使用服务过程中，如果您提供以下额外信息补全个人资料，将有助于我们给您提供更好的服务和体验:
        <b
          >职业、收入情况、工作区域、家乡、婚姻状况、住房情况、您本人的真实头像、择偶条件、录制语音、交友心声、微信号码</b
        >。但如果您不提供这些信息，将不会影响使用“{{ appName }}”产品或服务的基本功能。
      </div>
      <div class="privacy-content">
        （五） 我们会收集您提供的
        <b>微信支付信息、支付宝支付信息、苹果支付信息</b>，用于为您提供购买平台虚拟货币—爱心的服务。
      </div>
      <div class="privacy-content">
        （六） 我们会根据您在安装及使用“{{ appName }}”软件及相关服务的过程中
        <b>或“{{ appName }}”软件在后台运行时</b>授予的具体权限收集您所使用的<b
          >设备相关信息（包括设备型号、操作系统版本、设置参数、设备配置、设备标识（IMEI/Android
          ID/OAID/IDFA/IDFV/MEID/UDID/SIM卡IMSI信息/ICCID等）、设备序列号、MAC地址、设备网络信息(运营商信息/WIFI信息/SSID/BSSID)、设备环境、SD card信息、软件列表、运行中的进程信息等软硬件特征信息）、设备所在位置相关信息（包括您授权的GPS位置以及WLAN接入点、蓝牙和基站等传感器信息）。</b
        >
        用于向您提供更契合您需求的展示和搜索结果、了解产品适配性、识别账号异常状态。
      </div>
      <div class="privacy-content">
        （七） 我们会收集您使用“{{ appName }}”软件及相关服务的
        <b>网络日志信息（您使用“{{ appName }}”软件及相关服务的日期、时间等）</b
        >，用于识别账号异常状态及满足相关法律法规的要求。
      </div>
      <div class="privacy-content">
        （八） 我们可能使用或整合您的
        <b>用户信息、设备信息及有关网络日志</b
        >，为提高您使用我们提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或“{{
          appName
        }}”相关协议规则的情况，并用于综合判断您账户风险、进行账户验证、检测及防范安全事件，并依法采取必要的记录、分析、处置措施。
      </div>
      <div class="privacy-content">
        （九） 我们可能会在您与我们联系时保存您的
        <b>通信/通话记录和内容或您留下的联系方式</b
        >等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。
      </div>
      <div class="privacy-content">（十） 我们需要您开启自启动以保障消息能及时送达。</div>
      <div class="privacy-content">
        （十一）当您使用{{
          appName
        }}服务时，为实现信息分享、参加相关活动等目的所必需，我们可能会调用剪切板并使用与功能相关的最小必要信息（口令、链接、统计参数等）。
      </div>
      <div class="privacy-content">
        （十二）我们会收集您的传感器信息（陀螺仪、步测器、光线、加速度、磁场、距离、旋转矢量等传感器信息），通过传感器获取设备状态（方向、角度、加速度等）用于拍摄时调整画面角度帮助您使用正确的角度体验产品或者语音时调整声音播放方式（听筒扬声器转换）为您提供更好的适配效果以及保障账号安全，为您提供安全、可信的产品与使用环境。
      </div>
      <div class="privacy-content">（十三）征得授权同意的例外</div>
      <div class="privacy-content">
        <b>根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：</b>
      </div>
      <div class="privacy-content">（1）与我们履行法律法规规定的义务相关的；</div>
      <div class="privacy-content">（2）与国家安全、国防安全有关的；</div>
      <div class="privacy-content">
        （3）与公共安全、公共卫生、重大公共利益有关的；
      </div>
      <div class="privacy-content">
        （4）与犯罪侦查、起诉、审判和判决执行等有关的；
      </div>
      <div class="privacy-content">
        （5）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
      </div>
      <div class="privacy-content">
        （6）所收集的个人信息是您自行向社会公众公开的；
      </div>
      <div class="privacy-content">
        （7）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
      </div>
      <div class="privacy-content">（8）根据您的要求签订合同所必需的；</div>
      <div class="privacy-content">（9）法律法规规定的其他情形。</div>
      <div class="privacy-content">
        <b
          >如我们停止运营“{{
            appName
          }}”软件及相关服务，我们将立即停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并按相关法律法规的规定对所持有的个人信息进行删除或匿名化处理。</b
        >
      </div>
      <div class="privacy-title">二、我们可能需要获取的您的设备权限</div>
      <div class="privacy-content">
        （一） 我们需要获取访问您的
        <b>手机相册（存储权限）</b
        >的授权，用于为您提供您选择您手机相册里的一张照片作为您的账号头像或作为动态内容进行发布，如您不使用我们提供的上述服务，则我们不会访问您的手机相册，
        <b>您也可以随时取消对我们访问您的手机相册的授权。</b>
      </div>
      <div class="privacy-content">
        （二） 我们需要获取访问您的
        <b>手机相机</b
        >的授权，用于为您提供您拍摄一张照片作为您的账号头像或作为动态内容进行发布，如您不使用我们提供的上述服务，则我们不会访问您的手机相机，
        <b>您也可以随时取消对我们访问您的手机相机的授权。</b>
      </div>
      <div class="privacy-content">
        （三） 我们需要获取访问您的
        <b>手机相机</b
        >的授权，用于为您提供实名认证服务，如您不使用我们提供的上述服务，则我们不会访问您的手机相机，
        <b>您也可以随时取消对我们访问您的手机相机的授权。</b>
      </div>
      <div class="privacy-content">
        （四） 我们需要获取访问您的
        <b>手机相机</b>和
        <b>麦克风</b
        >的授权，用于为您提供您拍摄一段视频进行红娘/月老资格认证，如您不使用我们提供的上述服务，则我们不会访问您的手机相机，
        <b>您也可以随时取消对我们访问您的手机相机和麦克风的授权。</b>
      </div>
      <div class="privacy-content">
        （五） 我们需要获取访问您的
        <b>手机相机</b>和
        <b>麦克风</b
        >的授权，用于为您提供视频聊天服务，如您不使用我们提供的上述服务，则我们不会访问您的手机相机和麦克风，
        <b>您也可以随时取消对我们访问您的手机相机和麦克风的授权。</b>
      </div>
      <div class="privacy-content">
        （六） 我们需要获取访问您的
        <b>地理位置</b
        >的授权，用于为您提供您浏览查看附近的用户以及附近的交友房间，如您不使用我们提供的上述服务，则我们不会访问您的地理位置，
        <b>您也可以随时取消对我们访问您的地理位置的授权。</b>
      </div>
      <div class="privacy-content">
        （七） 我们需要获取您的
        <b>手机通知权限</b>，用于我们向您推送相关服务通知，如您不想收到上述通知，
        <b>则您可以随时关闭我们使用您手机通知的权限。</b>
      </div>
      <div class="privacy-content">
        （八） 我们需要获取您的
        <b>电话权限（设备信息权限）</b
        >，用于我们为您完成必要的账号安全检查，保障您的账号安全。如您不使用我们提供的上述服务，<b
          >您也可以随时取消我们访问您的电话权限（设备信息权限）的授权。</b
        >
      </div>
      <div class="privacy-title">三、我们如何共享、转让、披露您的个人信息</div>
      <div class="privacy-content">
        （一）
        <b>共享</b>
      </div>
      <div class="privacy-content">
        我们不会与“{{ appName }}”服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：
      </div>
      <div class="privacy-content">
        1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
      </div>
      <div class="privacy-content">
        2、在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。
      </div>
      <div class="privacy-content">
        3、与我们的关联方的必要共享。为向您提供一致化服务，我们可能会将您的个人信息与我们的关联版本共享。但我们只会共享必要的个人信息，并与本政策所声明的目的保持一致。具体共享您信息的类型、使用目的、共享第三方信息可查阅<b
          @click="gotoPage"
          >《授权协议》</b
        >。
      </div>
      <div class="privacy-content">
        4、 为了使您能够使用下述服务及功能，我们的应用中会接入第三方SDK：
      </div>
      <table class="tab1" width="98%" border="1" cellspacing="0">
        <tr class="thead">
          <th class="tr1">第三方公司名称</th>
          <th class="tr1">SDK名称</th>
          <th class="tr2">使用目的</th>
          <!-- <th class="tr3">客户端</th> -->
          <th class="tr4">获取信息</th>
          <th class="tr5">官网链接</th>
        </tr>
        <tr>
          <th class="tr1">北京小米移动软件有限公司</th>
          <th class="tr1">小米推送SDK</th>
          <th class="tr2">消息推送</th>

          <th class="tr4">
            设备标识(IMEI、MEID、OAID、加密的Android
            ID、SN)、推送消息内容、设备厂商、型号、归属地、运营商名称、通知栏设置、访问网络状态、写入设备存储
          </th>
          <th class="tr5">
            <a href="https://dev.mi.com/console/doc/detail?pId=1822"
              >https://dev.mi.com/console/doc/detail?pId=1822</a
            >
          </th>
        </tr>
        <tr>
          <th>华为软件技术有限公司</th>
          <th>华为推送SDK</th>
          <th>消息推送</th>
          <!-- <th>Android</th> -->
          <th>应用基本信息、应用内设备标识符、设备的硬件信息、系统基本信息和系统设置信息</th>
          <th class="tr5">
            <a
              href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177"
              >https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177</a
            >
          </th>
        </tr>
        <tr>
          <th class="tr1">维沃移动通信有限公司</th>
          <th class="tr1">Vivo推送SDK</th>
          <th class="tr2">消息推送</th>

          <th class="tr4">
            应用安装列表、设备标识符（如IMEI、ICCID 、EMMCID/UFSID 、OAID/VAID/AAID、SN码 和
            IMSI、Android ID和VIVO安卓设备的移动网号）、MAC地址
          </th>
          <th class="tr5">
            <a href="https://www.vivo.com.cn/about-vivo/privacy-policy"
              >https://www.vivo.com.cn/about-vivo/privacy-policy</a
            >
          </th>
        </tr>
        <tr>
          <th class="tr1">广东欢太科技有限公司</th>
          <th class="tr1">OPPO推送SDK</th>
          <th class="tr2">消息推送</th>

          <th class="tr4">
            设备标识（IMEI或OAID、SN、IMSI、Android
            ID、GAID）、应用信息（APP包名及版本号，运行状态）、网络信息（IP或域名连接结果，当前网络类型）
          </th>
          <th class="tr5">
            <a href="https://open.oppomobile.com/new/developmentDoc/info?id=10288"
              >https://open.oppomobile.com/new/developmentDoc/info?id=10288</a
            >
          </th>
        </tr>
        <!-- <tr>
          <th class="tr1">OPPO推送SDK</th>
          <th class="tr1">OPPO推送SDK</th>
          <th>支付</th>
          <th>Android</th>
          <th>设备信息、存储</th>
          <th class="tr5">
            <a href="https://render.alipay.com/p/f/fd-jm7jym6r/alipay/multi-agreement.html"
              >https://render.alipay.com/p/f/fd-jm7jym6r/alipay/multi-agreement.html</a
            >
          </th>
        </tr> -->
        <!-- <tr>
          <th class="tr1">OPPO推送SDK</th>
          <th class="tr1">OPPO推送SDK</th>
          <th>为用户提供安全的身份验证服务</th>
          <th>Android/iOS</th>
          <th>设备信息（IMSI、SIM卡信息）</th>
          <th class="tr5">
            <a
              href="https://www.aliyun.com/product/cloudauth?spm=5176.13910061.1141376.1.58c115d2XuMMsZ"
              >https://www.aliyun.com/product/cloudauth?spm=5176.13910061.1141376.1.58c115d2XuMMsZ</a
            >
          </th>
        </tr> -->
        <!-- <tr>
          <th>百川云旺SDK</th>
          <th>百川云旺SDK</th>
          <th>即时聊天</th>
          <th>Android/iOS</th>
          <th>设备信息、存储、麦克风</th>
          <th class="tr5">
            <a href="https://baichuan.taobao.com/product/im.htm"
              >https://baichuan.taobao.com/product/im.htm</a
            >
          </th>
        </tr> -->
        <!-- <tr>
          <th>Zxing SDK</th>
          <th>Zxing SDK</th>
          <th>生成二维码</th>
          <th>Android/iOS</th>
          <th>相机、麦克风</th>
          <th class="tr5">
            <a href="https://policies.google.com/privacy?hl=zh-cn"
              >https://policies.google.com/privacy?hl=zh-cn</a
            >
          </th>
        </tr>
        <tr>
          <th>高德地图SDK</th>
          <th>高德地图SDK</th>
          <th>用于实现定位</th>
          <th>Android/iOS</th>
          <th>设备信息、存储、地理位置信息</th>
          <th class="tr5">
            <a href="https://lbs.amap.com/home/privacy">https://lbs.amap.com/home/privacy</a>
          </th>
        </tr> -->
        <tr>
          <th>支付宝（中国）网络技术有限公司</th>
          <th>支付宝支付SDK</th>
          <th>支付、提现</th>

          <th>
            设备标识（IMEI、IMSI、硬件序列号、Android
            ID、ICCID、SIM卡序列号）、MAC地址、设备屏幕密度、网络信息（网络类型、wifi信息、运营商信息、BSSID、SSID）、应用数据、运行进程信息存储
          </th>
          <th class="tr5">
            <a href="https://render.alipay.com/p/f/fd-jm7jym6r/alipay/multi-agreement.html"
              >https://render.alipay.com/p/f/fd-jm7jym6r/alipay/multi-agreement.html</a
            >
          </th>
        </tr>
        <tr>
          <th>阿里云计算有限公司</th>
          <th>阿里实名认证SDK</th>
          <th>为用户提供安全的身份验证服务</th>

          <th>
            设备信息（Android
            ID、OAID、IDFA、BSSID、SSID、IMEI、IMSI、MAC、SN、传感器信息、ICCID）、最终用户上传的图片信息、运营商信息、终端权限信息(存储、摄像头、电话、位置、网络）
          </th>
          <th class="tr5">
            <a
              href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202111292014_72878.html"
              >https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202111292014_72878.html</a
            >
          </th>
        </tr>
        <tr>
          <th>浙江淘宝网络有限公司</th>
          <th>百川云旺SDK</th>
          <th>即时聊天</th>

          <th>
            应用列表信息、设备标识符（Android如IMEI/安卓广告主标识符，iOS如IDFA）、IP地址、MAC地址、传感器参数、网络状态（WiFi等）、存储、麦克风、运行中的进程信息、剪切板
          </th>
          <th class="tr5">
            <a
              href="https://terms.alicdn.com/legal-agreement/terms/suit_bu1_taobao/suit_bu1_taobao202107141244_11649.html?spm=a3c0d.7662652.1998907877.3.100abe48zszzqW"
              >https://terms.alicdn.com/legal-agreement/terms/suit_bu1_taobao/suit_bu1_taobao202107141244_11649.html?spm=a3c0d.7662652.1998907877.3.100abe48zszzqW</a
            >
          </th>
        </tr>
        <tr>
          <th>Google LLC</th>
          <th>Zxing SDK</th>
          <th>生成二维码</th>

          <th>相机、光线传感器</th>
          <th class="tr5">
            <a href="https://policies.google.com/privacy?hl=zh-cn"
              >https://policies.google.com/privacy?hl=zh-cn</a
            >
          </th>
        </tr>
        <tr>
          <th>高德软件有限公司</th>
          <th>高德地图SDK</th>
          <th>用于实现定位</th>

          <th>
            设备标识（IMEI、IDFA、IDFV、Android
            ID、MEID、OAID、IMSI、硬件序列号）MAC地址、蓝牙信息、传感器信息（矢量、加速度、压力）、WiFi信息、SSID、BSSID、网络运营商、当前应用信息（应用名、应用版本号）、设备参数及系统信息、地理位置信息（GNSS信息、基站信息、GPS）、SIM卡状态信息、存储
          </th>
          <th class="tr5">
            <a href="https://lbs.amap.com/home/privacy">https://lbs.amap.com/home/privacy</a>
          </th>
        </tr>
        <!-- <tr>
          <th>声网SDK</th>
          <th>声网SDK</th>
          <th>连麦</th>
          <th>Android/iOS</th>
          <th>相机、麦克风</th>
          <th class="tr5">
            <a href="https://www.agora.io/cn/privacy-policy/"
              >https://www.agora.io/cn/privacy-policy/</a
            >
          </th>
        </tr> -->
        <tr>
          <th>小沃科技有限公司</th>
          <th>联通SDK</th>
          <th>一键登录</th>

          <th>设备标识（IMSI、SIM卡信息）、MAC地址、本机号码</th>
          <th class="tr5">
            <a href="https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?fromsdk=true"
              >https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?fromsdk=true</a
            >
          </th>
        </tr>
        <tr>
          <th>中移互联网有限公司</th>
          <th>移动SDKK</th>
          <th>一键登录</th>

          <th>设备标识（IMSI、SIM卡信息）、MAC地址、本机号码、SIM卡状态信息</th>
          <th class="tr5">
            <a href="https://wap.cmpassport.com/resources/html/contract.html"
              >https://wap.cmpassport.com/resources/html/contract.html</a
            >
          </th>
        </tr>
        <tr>
          <th>世纪龙信息网络有限责任公司</th>
          <th>电信SDK</th>
          <th>一键登录</th>
          <!-- <th>Android</th> -->
          <th>设备标识（IMSI、SIM卡信息、Android ID）、任务列表、MAC地址、本机号码</th>
          <th class="tr5">
            <a
              href="https://e.189.cn/sdk/agreement/show.do?order=2&type=main&appKey=&hidetop=true&returnUrl="
              >https://e.189.cn/sdk/agreement/show.do?order=2&type=main&appKey=&hidetop=true&returnUrl=</a
            >
          </th>
        </tr>
        <tr>
          <th>阿里云计算有限公司</th>
          <th>阿里云对象存储 OSS SDK</th>
          <th>实人认证组件</th>

          <th>存储</th>
          <th class="tr5">
            <a href="https://help.aliyun.com/product/31815.html"
              >https://help.aliyun.com/product/31815.html</a
            >
          </th>
        </tr>
        <tr>
          <th>上海兆言网络科技有限公司</th>
          <th>声网SDK</th>
          <th>连麦</th>

          <th>设备信息（Android ID、传感器）、相机、麦克风</th>
          <th class="tr5">
            <a href="https://www.agora.io/cn/privacy-policy/"
              >https://www.agora.io/cn/privacy-policy/</a
            >
          </th>
        </tr>
        <tr>
          <th>北京百度网讯科技有限公司</th>
          <th>百度地图SDK</th>
          <th>用于实现定位</th>

          <th>
            设备标识（Android
            ID）、设备信息（操作系统版本、设备品牌及型号、设备配置、应用信息、MAC地址、传感器信息（加速度，陀螺仪、方向、压力、旋转矢量、光照、磁力计））、访问WiFi状态（包括WiFi状态、WiFi参数和WiFi列表、SSID、BSSID）、地理位置信息、SIM卡状态信息
          </th>
          <th class="tr5">
            <a href="http://lbsyun.baidu.com/index.php?title=open/privacy"
              >http://lbsyun.baidu.com/index.php?title=open/privacy</a
            >
          </th>
        </tr>
        <tr>
          <th>深圳市腾讯计算机系统有限公司</th>
          <th>腾讯TBS SDK</th>
          <th>优化浏览服务</th>

          <th>
            设备信息（IMSI、SIM卡信息、设备型号、操作系统、CPU类型
            ）、存储、位置信息、wifi信息、CellID、剪切板
          </th>
          <th class="tr5">
            <a href="https://x5.tencent.com/docs/privacy.html"
              >https://x5.tencent.com/docs/privacy.html</a
            >
          </th>
        </tr>
        <tr>
          <th>电信终端产业协会</th>
          <th>OAID SDK</th>
          <th>移动联盟广告标识符</th>

          <th>设备信息、运营商信息</th>
          <th class="tr5">
            <a href="http://www.msa-alliance.cn/">http://www.msa-alliance.cn/</a>
          </th>
        </tr>
        <tr>
          <th>深圳市腾讯计算机系统有限公司</th>
          <th>腾讯云直播推流SDK</th>
          <th>直播</th>

          <th>Wi-Fi 状态、系统属性、设备型号、操作系统、IP 地址、相机、麦克风、存储、蓝牙</th>
          <th class="tr5">
            <a href="https://cloud.tencent.com/document/product/454/61839"
              >https://cloud.tencent.com/document/product/454/61839</a
            >
          </th>
        </tr>
        <tr>
          <th>深圳市腾讯计算机系统有限公司</th>
          <th>微信SDK</th>
          <th>第三方登录、支付、分享</th>

          <th>设备信息（IMEI、ICCID、Android ID）、MAC地址</th>
          <th class="tr5">
            <a
              href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8"
              >https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</a
            >
          </th>
        </tr>
        <tr>
          <th>武汉极意网络科技有限公司</th>
          <th>极验SDK</th>
          <th>安全风控</th>

          <th>
            设备信息（设备系统信息、设备厂商信息、设备型号、设备品牌等）、设备网络、设备环境、用户生物轨迹信息、验证时间戳、安装包名等、传感器信息
          </th>
          <th class="tr5">
            <a href="https://www.geetest.com/Private">https://www.geetest.com/Private</a>
          </th>
        </tr>
        <tr>
          <th>深圳市分秒网络科技有限公司</th>
          <th>Openinstall SDK</th>
          <th>统计分析</th>

          <th>
            设备信息（IMEI、IDFA、OAID、Mac地址、Android
            ID、SerialNumber、设备品牌，设备型号，操作系统版本，IP地址）、剪切板
          </th>
          <th class="tr5">
            <a href="https://www.openinstall.io/privacy.html"
              >https://www.openinstall.io/privacy.html</a
            >
          </th>
        </tr>
        <tr>
          <th>北京壹六零二信息技术有限公司</th>
          <th>Rifle SDK</th>
          <th>移动质量管理，崩溃记录和上报</th>

          <th>
            设备信息（设备系统信息、设备厂商信息、设备型号、设备标识符等信息）、设备网络信息（设备联网状态和类型等信息）、运行的进程信息
          </th>
          <th class="tr5">
            <a href="https://cosmos.immomo.com/home/copyright"
              >https://cosmos.immomo.com/home/copyright</a
            >
          </th>
        </tr>
        <tr>
          <th>北京壹六零二信息技术有限公司</th>
          <th>cosmos push SDK</th>
          <th>为用户提供Push 通知</th>

          <th>
            设备信息（设备系统信息、设备厂商信息、设备型号、设备标识符等信息）、设备网络信息（设备联网状态和类型等信息）、运行的进程信息
          </th>
          <th class="tr5">
            <a href="https://cosmos.immomo.com/home/copyright"
              >https://cosmos.immomo.com/home/copyright</a
            >
          </th>
        </tr>
        <tr>
          <th>——</th>
          <th>com.liulishuo.filedownloader</th>
          <th>Android 文件下载引擎</th>

          <th>运行的进程信息</th>
          <th class="tr5">
            <a href="https://github.com/lingochamp/FileDownloader/blob/master/README-zh.md"
              >https://github.com/lingochamp/FileDownloader/blob/master/README-zh.md</a
            >
          </th>
        </tr>

         <tr>
          <th>——</th>
          <th>MklibrarySDK</th>
          <th>webview封装</th>

          <th>SD card信息</th>
          <th class="tr5">
            <a href="https://cosmos.immomo.com/home/copyright"
              >https://cosmos.immomo.com/home/copyright</a
            >
          </th>
        </tr>
      </table>

      <div class="privacy-content">
        我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。
      </div>
      <div class="privacy-content">
        （二）
        <b>转让</b>
      </div>
      <div class="privacy-content">
        我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
      </div>
      <div class="privacy-content">
        1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息。
      </div>
      <div class="privacy-content">
        2、在涉及合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。
      </div>

      <div class="privacy-content">（三）<b>披露</b></div>
      <div class="privacy-content">
        我们不会向任何第三方披露您的个人信息，但以下情形除外：
      </div>
      <div class="privacy-content">
        1、您自主自愿选择披露或另行授权我们披露给第三方时，我们会将您同意或选择披露的个人信息披露给您指定的第三方。
      </div>
      <div class="privacy-content">
        2、我们依据相关法律法规基于下述情形披露您的个人信息：
      </div>
      <div class="privacy-content">1）与国家安全、国防安全有关的；</div>
      <div class="privacy-content">
        2）与公共安全、公共卫生、重大公共利益有关的；
      </div>
      <div class="privacy-content">
        3）与犯罪侦查、起诉、审判和判决执行等有关的；
      </div>
      <div class="privacy-content">
        4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
      </div>
      <div class="privacy-content">
        5）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
      </div>
      <div class="privacy-content">
        6）其他法律法规规定或司机机关要求的情形。
      </div>
      <div class="privacy-content">
        根据《中华人民共和国网络安全法》等相关法律法规的规定，<b
          >共享、转让、披露经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及披露行为，对此类数据的保存及处理将不再另行向您通知并征得您的同意。</b
        >
      </div>

      <div class="privacy-title">四、我们如何保护您的个人信息</div>
      <div class="privacy-content">
        （一）我们努力为用户的个人信息提供安全保障，以防止用户个人信息的非法使用、未经授权的访问和披露、泄漏、损坏和丢失。我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，我们会使用加密技术（例如，SSL）、匿名化处理、加密存储等手段来保护你的个人信息；建立受信赖的保护机制防止个人信息遭到恶意攻击；建立访问控制机制，遵守最小权限原则，确保只有授权人员才可访问个人信息；开展安全和个人信息保护培训课程，加强员工对于保护个人信息保护的认识。
      </div>
      <div class="privacy-content">
        （二）我们有行业先进的以数据为核心，围绕数据生命周期进行的数据安全管理体系，从管理机构、组织建设、制度体系、产品技术等方面多维度提升整个系统的安全性。我们建立专门的管理制度、流程和组织以保障个人信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。
      </div>
      <div class="privacy-content">
        （三）我们会采取合理可行的措施，尽力避免收集无关的个人信息。
        如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络我们，以便我们根据您的申请采取相应措施。
      </div>
      <div class="privacy-content">
        如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络我们，以便我们根据您的申请采取相应措施。
      </div>
      <div class="privacy-content">
        请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息，请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。
      </div>
      <div class="privacy-content">
        同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
      </div>
      <div class="privacy-title">五、您如何管理您的个人信息</div>
      <div class="privacy-content">
        您可以通过以下方式访问及管理您的个人信息：
      </div>
      <div class="privacy-content"><b>（一）访问您的个人信息</b></div>
      <div class="privacy-content">
        您有权访问您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问您的个人信息：
      </div>
      <div class="privacy-content">
        账户信息—如果您希望访问或编辑您的账户中的个人资料信息，如头像和昵称，您可以通过通过点击我的-编辑资料来执行此类操作。
      </div>
      <div class="privacy-content">
        如果您无法通过上述路径访问该等个人信息，您可以随时通过“{{
          appName
        }}”客服与我们取得联系。我们将在15天内回复您的访问请求。
      </div>
      <div class="privacy-content">
        对于您在使用我们的产品或服务过程中产生的其他个人信息，我们将根据本条“（六）响应您的上述请求”中的相关安排向您提供。
      </div>
      <div class="privacy-content"><b>（二）更正或补充您的个人信息</b></div>
      <div class="privacy-content">
        当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正或补充。您可以通过本条“（一）访问您的个人信息”中列明的方式提出更正或补充申请。
      </div>
      <div class="privacy-content"><b>（三）删除您的个人信息</b></div>
      <div class="privacy-content">
        您可以通过本条“（一）访问您的个人信息”中列明的方式删除您的部分个人信息。
      </div>
      <div class="privacy-content">
        在以下情形中，您可以向我们提出删除个人信息的请求：
      </div>
      <div class="privacy-content">
        1、如果我们处理个人信息的行为违反法律法规；
      </div>
      <div class="privacy-content">
        2、如果我们收集、使用您的个人信息，却未征得您的明确同意；
      </div>
      <div class="privacy-content">
        3、如果我们处理个人信息的行为严重违反了与您的约定；
      </div>
      <div class="privacy-content">
        4、如果您不再使用我们的产品或服务，或您主动注销了账号；
      </div>
      <div class="privacy-content">5、如果我们永久不再为您提供产品或服务。</div>
      <div class="privacy-content">
        若我们决定响应您的删除请求，我们会及时删除。
      </div>
      <div class="privacy-content">
        <b
          >当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。</b
        >
      </div>
      <div class="privacy-content"><b>（四）改变您授权同意的范围</b></div>
      <div class="privacy-content">
        每个业务功能需要一些基本的个人信息才能得以完成（见本隐私政策“第一条”）。除此之外，对于额外个人信息的收集和使用，您可以在设置或与“{{
          appName
        }}”客服联系给予或收回您的授权同意。
      </div>
      <div class="privacy-content">
        当您收回同意后，我们将不再使用相应的个人信息。<b
          >但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</b
        >
      </div>
      <div class="privacy-content"><b>（五）个人信息主体注销账户</b></div>
      <div class="privacy-content">
        您可以自行在“设置”-“安全协议”-“账户注销”页面提交账户注销申请。
      </div>
      <div class="privacy-content">
        我们按本政策收集的您的个人信息，将在您注销后立即删除或按相关法律法规的规定进行匿名化处理，但按相关法律法规或司法机关的要求需要延长保存时间的除外。在延长保存期间内，我们会以加密形式安全地存储您的个人信息并进行隔离，直至按相关法律法规或司法机关的要求可以删除或匿名化处理。
      </div>
      <div class="privacy-content"><b>（六）响应您的上述请求</b></div>
      <div class="privacy-content">
        为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
      </div>
      <div class="privacy-content">
        我们将在15天内做出答复。如您不满意，还可以通过“{{ appName }}”客服发起投诉。
      </div>
      <div class="privacy-content">
        对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。
      </div>
      <div class="privacy-content">
        在以下情形中，按照法律法规要求，我们将无法同意您的请求：
      </div>
      <div class="privacy-content">1、与国家安全、国防安全有关的；</div>
      <div class="privacy-content">
        2、与公共安全、公共卫生、重大公共利益有关的；
      </div>
      <div class="privacy-content">
        3、与犯罪侦查、起诉、审判和执行判决等有关的；
      </div>
      <div class="privacy-content">
        4、有充分证据表明个人信息主体存在主观恶意或滥用权利的；
      </div>
      <div class="privacy-content">
        5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
      </div>
      <div class="privacy-content">6、涉及商业秘密的。</div>
      <div class="privacy-title"><b>六、我们如何处理未成年人的个人信息</b></div>
      <div class="privacy-content">
        任何18岁以下的未成年人均不得创建自己的用户账户及/或使用我们的服务。
      </div>
      <div class="privacy-content">
        我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或披露涉及未成年人的个人信息。
      </div>
      <div class="privacy-title">
        <b>七、我们存储您的个人信息的位置和方式</b>
      </div>
      <div class="privacy-content">
        我们按本政策收集的您的个人信息，存储在中国境内。
      </div>
      <div class="privacy-content">
        我们按本政策收集的您的个人信息，以加密的方式存储。
      </div>
      <div class="privacy-content">
        我们按本政策收集的您的个人信息，将在您删除或注销后立即删除或按相关法律法规的规定进行匿名化处理，但按相关法律法规或司法机关的要求需要延长保存时间的除外。在延长保存期间内，我们会以加密形式安全地存储您的个人信息并进行隔离，直至按相关法律法规或司法机关的要求可以删除或匿名化处理。
      </div>
      <div class="privacy-title">八、本隐私政策如何更新</div>
      <div class="privacy-content">我们的隐私政策可能变更。</div>
      <div class="privacy-content">
        未经您明确同意，我们不会限制您按照本隐私政策所应享有的权利。对于重大变更，我们会提供显著的通知（包括我们会通过“{{
          appName
        }}”公示的方式进行通知甚至向您提供弹窗提示）。
      </div>
      <div class="privacy-content">本政策所指的重大变更包括但不限于：</div>
      <div class="privacy-content">
        1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
      </div>
      <div class="privacy-content">
        2、我们在控制权等方面发生重大变化。如并购重组等引起的所有者变更等；
      </div>
      <div class="privacy-content">
        3、个人信息共享、转让或公开披露的主要对象发生变化；
      </div>
      <div class="privacy-content">
        4、您参与个人信息处理方面的权利及其行使方式发生重大变化；
      </div>
      <div class="privacy-content">
        5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
      </div>
      <div class="privacy-content">
        6、个人信息安全影响评估报告表明存在高风险时。
      </div>
      <div class="privacy-content">
        我们还会将本隐私权政策的旧版本存档，供您查阅。
      </div>
      <div class="privacy-title">九、如何联系我们</div>
      <div class="privacy-content">
        1、您可以通过“{{ appName }}”客服与我们联系，我们将在15天内回复您的请求。
      </div>
      <div class="privacy-content">
        2、如发现个人信息可能被泄露，您可以发邮件至hnqx.src@immomo.com投诉举报。
      </div>
      <div class="privacy-content">
        3、我们的常用办公地址为北京市朝阳区望京SOHO塔2，B座20层，个人信息保护相关负责人的联系方式为hnqx.src@immomo.com。
      </div>
      <div class="privacy-content">
        如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，<b
          >您还可以通过向本协议签订地有管辖权的法院提起诉讼来寻求解决方案，本协议签订地为北京市朝阳区。</b
        >
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.tab1 {
  margin: 0 auto;
  margin-bottom: 20px;
  line-height: 30px;
  color: #9a9eb9;
  text-align: center;
  border-color: #eee;
  tr {
    font-size: 16px;
  }
  .tr1 {
    width: 100px;
  }
  .tr2 {
    min-width: 40px;
  }
  .tr3 {
    width: 80px;
  }
  .tr4 {
    width: 100px;
  }
  .tr5 {
    max-width: 350px;
    word-break: break-all;
  }
}
.thead {
  color: #3f446f;
  font-size: 24px;
  line-height: 30px;
  margin-top: 7px;
  text-align: center;
}
.privacy {
  background-color: #f6f5fb;
}
.privacy-wrapper {
  padding-top: 120px;
  padding: 120px 30px 0 30px;
  width: 690px;
  text-align: left;
}
.privacy-title {
  margin-bottom: 40px;
  font-family: "PingFangSC-Medium";
  font-size: 30px;
  color: rgb(63, 68, 111);
}
.privacy-date {
  margin-left: 300px;
  margin-bottom: 4px;
  text-align: right;
  font-size: 26px;
  width: 390px;
  color: #3f446f;
}
.privacy-date-second {
  margin-bottom: 20px;
}
.privacy-content {
  font-size: 26px;
  color: #3f446f;
  line-height: 41px;
  padding-bottom: 40px;
  .phone {
    text-decoration: underline;
  }
}
</style>
<script>
import HeaderTop from "src/components/HeaderTop.vue";

const { mm } = window;
export default {
  name: "Privacy",
  data() {
    return {
      IOSUser: false,
      appName: this.$store.state.appName
    };
  },
  mounted() {},
  components: {
    "header-top": HeaderTop // 顶部导航组件
  },
  created() {
    console.log("appName:", this.appName);
    const iOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (iOS) {
      this.IOSUser = iOS;
      // console.log("iOS终端", iOS);
    }
  },
  methods: {
    callServe(phone) {
      mm.ui.openUrl({
        target: 3,
        url: ` goto://MultiFunction_Action_Protocol?action=dail&content=${phone}`
      });
    },
    gotoPage() {
      this.$router.push({
        name: "empower"
      });
    }
  }
};
</script>
